export const environment = {
    production: false,
    msalConfig: {
        auth: {
            clientId: '6c97a4d2-9c35-4528-bc13-410a4ad0bb77',
            authority: 'https://login.microsoftonline.com/46c5178e-a0f4-4f4d-8c40-9598e3d11860', 
        }
    },
    graphApiConfig:{
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    apiConfig: {
        uri: 'https://cw-va-api-dev.azurewebsites.net/', // your API base URL
        scopes: [
            'api://92884067-bd0c-4db1-8d38-49f4402a3087/access_as_user' // backend API scope
        ]
    },
    apiBaseUrl: 'https://cw-va-api-dev.azurewebsites.net',
    appraisalApiConfig:{
        baseUrl: 'https://cw-va-api-dev.azurewebsites.net/api/v1/appraisal'
    },
    argusApiConfig:{
        baseUrl: 'https://cw-va-api-dev.azurewebsites.net'
    },
    bookmarksApiConfig:{
        baseUrl: 'https://cw-va-api-dev.azurewebsites.net/api/v1/bookmarks',
        /* Saved views run on an in-memory store until the bookmarks API is
           reachable from here; they last until the page reloads. Flip to
           false to go live. */
        useMock: true
    },
    ratingsApiConfig:{
        baseUrl: 'https://cw-va-api-dev.azurewebsites.net/api/v1'
    },
    reportStudioApi: {
        baseUrl: 'https://cw-va-api-dev.azurewebsites.net/api/v1',
        /* The report writing endpoints are not deployed yet; the feature runs on
           its in-memory transport until they are. Flip to false to go live. */
        useMock: true
    },
    /*
       The assignments module - valuation records and the work around them.
       `useMock` keeps the feature on its in-memory transport until the
       endpoints ship in the Valuations API; flip it to false to go live.

       There is no `enabled` switch any more. It was the dark-launch flag for
       the Singapore pilot, and a flag that unregisters the Assignments routes
       would now take the portal's main surface with it - who sees the module
       is a capability, in `@core/access`.
    */
    valuationsApi: {
        baseUrl: 'https://cw-va-api-dev.azurewebsites.net/api/v1',
        useMock: true,
        /*
           Read the legacy Singapore IVS database for search and master data
           while writes stay in memory. A migration aid, not a general mode:
           it needs the Valuations API running with ConnectionStrings:IvsDb
           set, and the signed-in address present in dbo.ivs_user - without
           that the API answers 403.
        */
        liveSearch: false,
        /*
           TEMPORARY. Where the in-memory transport reads its records: the
           IVS extract, served by the host as a stand-in for the backend feed
           (scripts/ivs-extract). Only read while useMock is on; null = seed
           records only. Remove with the in-memory transport.
        */
        referenceDataUrl: '/mock-api/ivs/records.json' as string | null
    },
    signalRConfig: {
        hubUrl: 'https://cw-va-api-dev.azurewebsites.net/hubs/grid-refresh',
        refreshEvents: [ 'AppraisalUpdated'],
        pollingIntervalMs: 10000
    },
    /*
       Feature flags - the shipped baseline for this environment. The flags,
       their defaults and what each one switches off are in
       src/core/access/flags.ts; a flag left out of `values` keeps its default.
       /feature-flags.json on the host overrides these without a rebuild, and
       Settings > Feature flags overrides them per Global / region / country.

       e.g.  values: { bulkBatches: false, ratings: true }
    */
    featureFlags: {
        values: {}
    },
    /*
       Organisation settings - scoped flags, formats, role defaults, rules.
       The Settings API is not deployed yet; `useMock` keeps them in the
       browser that saved them. Flip to false to go live. A production build
       on the mock shows Settings read-only.
    */
    settingsApi: {
        baseUrl: 'https://cw-va-api-dev.azurewebsites.net/api/v1',
        useMock: true
    },
    /*
       Natural-language search over the opportunity records (Home > Ask).
       The question is read into a query plan that the Opportunity Search API
       runs against the database (docs/opportunity-search-api.md). `useMock`
       runs the plan in the browser over the in-memory records instead, until
       the API ships; flip to false to go live. `interpretWithAi` lets the API's
       model read the question into a plan first - validated, with the
       browser's own reading as the fallback.
    */
    opportunitySearchApi: {
        baseUrl: 'https://cw-va-api-dev.azurewebsites.net/api/v1/opportunity-search',
        useMock: true,
        interpretWithAi: false
    },
    googleMapsApiKey: 'AIzaSyDwAy9oeS6R19NyU_kaj2BQdjWMxzboO_A',
    /*
       OneMap, the Singapore Land Authority's basemap - drawn instead of
       Google wherever Settings > Formats > Map resolves to OneMap (Singapore,
       by its profile). Tiles and Search are public and need no key; point
       these at a proxy where a network blocks onemap.gov.sg.
    */
    oneMap: {
        tileUrl: 'https://www.onemap.gov.sg/maps/tiles/{style}/{z}/{x}/{y}.png',
        searchUrl: 'https://www.onemap.gov.sg/api/common/elastic/search'
    }
};
